<template>
  <div
    class="sidebar"
    :data-background-color="backgroundColor"
    :data-active-color="activeColor"
  >
  <div class="logo text-center">
    <a class="simple-text">
      <div class="logo-img">
        <img src="@/assets/img/logo-2.png" alt="" />
        <img src="@/assets/img/logo-2.png" alt="" class="second"/>
        <img src="@/assets/img/logo-2.png" alt="" class="second"/>

      </div>
      <set-language></set-language>

      <template v-if="!$store.state.routes.length">
        <br />
        <p class="text-center text-danger">У вас нет ролей</p>
      </template>
    </a>
  </div>
    <div class="sidebar-wrapper" id="style-3">

      <slot> </slot>

      <ul class="nav">
        <div class="bg-active"></div>
        <slot name="links">
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="index"
            :to="link.path"
            :name="link.name"
            :icon="link.icon"
          >
          </sidebar-link>
        </slot>
      </ul>

      <!-- <moving-arrow :move-y="arrowMovePx"> </moving-arrow> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import MovingArrow from "./MovingArrow.vue";
import SidebarLink from "./SidebarLink";
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = ["white", "black", "darkblue"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
      addLink: this.addLink,
      removeLink: this.removeLink,
    };
  },
  components: {
    MovingArrow,
    SidebarLink,
  },
  computed: {
    ...mapState(["user"]),
    title: {
      get() {
        return this.user ? this.user.email : "";
      },
    },
    /**
     * Styles to animate the arrow near the current active sidebar link
     * @returns {{transform: string}}
     */
    arrowMovePx() {
      return this.linkHeight * this.activeLinkIndex;
    },
  },
  data() {
    return {
      linkHeight: 65,
      activeLinkIndex: 0,
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      links: [],
    };
  },
  methods: {
    ok(event){
      console.log(event)
    },
    findActiveLink() {
      this.links.forEach((link, index) => {
        if (link.isActive()) {
          this.activeLinkIndex = index;
          let activeEl = document.querySelector(".nav li.active")
          let bgEl = document.querySelector(".bg-active")
          let offsetTop = activeEl.offsetTop
          let width = activeEl.querySelector("a").offsetWidth
          console.log(bgEl)
          Object.assign(bgEl.style, {
            top: offsetTop+"px",
            width: width+"px"
          });
        }
      });
    },
    addLink(link) {
      const index = this.$slots.links.indexOf(link.$vnode);
      this.links.splice(index, 0, link);
    },
    removeLink(link) {
      const index = this.links.indexOf(link);
      if (index > -1) {
        this.links.splice(index, 1);
      }
    },
  },
  mounted() {
    this.$watch("$route", this.findActiveLink, {
      immediate: true,
    });
  },
};
</script>
<style>
</style>
